import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { ApolloClient, InMemoryCache, ApolloProvider, createHttpLink, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import App from './App';

/**
 * We're using Apollo and it's React plugin for the GraphQL queries
 */

const errorLink = onError(({ graphQLErrors, networkError, operation, response }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((err) => {
      console.error('[GraphQL error]:', err.message, {
        locations: err.locations,
        path: err.path,
        extensions: err.extensions,
        operationName: operation && operation.operationName,
        variables: operation && operation.variables,
        response,
        error: err,
      });
    });
  }
  if (networkError) {
    try {
      console.error('[Network error]:', networkError && networkError.message ? networkError.message : networkError, {
        statusCode: networkError && networkError.statusCode,
        result: networkError && networkError.result,
        operationName: operation && operation.operationName,
        variables: operation && operation.variables,
      });
    } catch (e) {
      console.error('[Network error]:', networkError);
    }
  }
});

const httpLink = createHttpLink({
  uri: '/wp/graphql/',
  credentials: 'same-origin',
});

const client = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache(),
});
/**
 * Inject the whole filter function into a div width the ID #rims-root.
 * This is injected via the shortcode [rims_widget], that is specified in ./includes/shortcode.php
 */

const target = document.getElementById('rims-root');

if (target) {
  ReactDOM.render(
    <React.StrictMode>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </React.StrictMode>,
    target
  );
}
